/* src/app/modules/taxes/model-184/model-184-renta-dialog/model-184-renta-dialog.component.css */
:host {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  min-width: 0;
}
.m184d-header-text {
  min-width: 0;
  padding-right: 32px;
}
.m184d-fs {
  border: 0;
  margin: 0;
  padding: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.m184d-vistas {
  display: flex;
  gap: 4px;
  margin-bottom: 14px;
  border-bottom: 1px solid var(--cf-border);
}
.m184d-vista {
  padding: 8px 16px;
  border: 0;
  border-bottom: 3px solid transparent;
  background: none;
  font-size: 13.5px;
  font-weight: 600;
  color: var(--cf-text-muted);
  cursor: pointer;
}
.m184d-vista--activa {
  color: var(--cf-text);
  border-bottom-color: var(--cf-brand);
}
.m184d-box {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px 14px 14px;
  border: 1px solid var(--cf-border);
  border-radius: var(--cf-radius);
  background: var(--cf-bg);
}
.m184d-subbox {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px 12px 12px;
  border: 1px solid var(--cf-border);
  border-radius: var(--cf-radius);
  background: var(--cf-surface);
}
.m184d-box__title {
  margin: 0;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.4;
  color: var(--cf-brand-dark);
}
.m184d-grid {
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  gap: 6px 12px;
  align-items: end;
}
.m184d-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}
.m184d-field ::ng-deep .mb-3 {
  margin-bottom: 0 !important;
}
.m184d-fila {
  align-self: center;
  font-size: 13px;
  color: var(--cf-text);
}
.m184d-aviso {
  color: #b45309;
}
.m184d-alert {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 12px;
  padding: 10px 14px;
  border: 1px solid #fecaca;
  border-left: 4px solid var(--cf-error);
  border-radius: var(--cf-radius);
  background: #fef2f2;
  font-size: 13px;
  color: var(--cf-text);
}
.m184d-alert mat-icon {
  flex: 0 0 auto;
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: var(--cf-error);
}
@media (max-width: 768px) {
  .m184d-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .m184d-grid > * {
    grid-column: span 1 !important;
  }
}
.m184d-vistas {
  display: flex;
  gap: 4px;
  margin-bottom: 14px;
  border-bottom: 1px solid var(--cf-border);
}
.m184d-vista {
  padding: 8px 16px;
  border: 0;
  border-bottom: 3px solid transparent;
  background: none;
  font-size: 13.5px;
  font-weight: 600;
  color: var(--cf-text-muted);
  cursor: pointer;
}
.m184d-vista--activa {
  color: var(--cf-text);
  border-bottom-color: var(--cf-brand);
}
/*# sourceMappingURL=model-184-renta-dialog.component.css.map */
